<script>
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedinIcon,
  MailIcon,
} from "vue-feather-icons";

export default {
  data() {
    return {
      lang: this.getLang(),
      follow: "wechat"
    };
  },
  methods: {
    showFollowModal(name) {
      this.follow = name;
      this.$bvModal.show("follow-modal1");
    }
  },
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    MailIcon,
  },
};
</script>

<template>
  <div>
    <!-- Footer Start -->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img loading="lazy" src="/images/logo-mirror-light.png" height="24" alt="Design Mirror" />
            </a>
            <p class="mt-4">
              {{$t('footer.description')}}
            </p>
            <ul class="list-unstyled mb-0 mt-4" v-if="lang === 'en'">
              <li class="list-inline-item">
                <a href="https://join.slack.com/t/designmirror/shared_invite/zt-11lp9jyhf-h5KLwZGchkzJ5CxWw6bw4A" class="rounded" target="_blank">
                  <font-awesome-icon :icon="['fab', 'slack']"></font-awesome-icon>
                </a>
              </li>
              <li class="list-inline-item ml-3">
                <a href="https://twitter.com/UI_DesignMirror" target="_blank">
                  <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                </a>
              </li>
            </ul>
            <ul class="list-unstyled mb-0 mt-4" v-if="lang === 'zh'">
              <li class="list-inline-item">
                <a href="https://weibo.com/u/5065292041" class="rounded" target="_blank">
                  <font-awesome-icon :icon="['fab', 'weibo']"></font-awesome-icon>
                </a>
              </li>
              <li class="list-inline-item ml-3">
                <a href="javascript:void(0)"  @click.prevent="showFollowModal('wechat')" class="rounded">
                  <font-awesome-icon :icon="['fab', 'weixin']"></font-awesome-icon>
                </a>
              </li>
            </ul>
            <!--end icon-->
          </div>
          <!--end col-->

          <div class="col-lg-5 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="text-light footer-head">{{$t('footer.link')}}</h5>
            <ul class="list-unstyled footer-list mt-4">
              <!--
                这一组链接混了外链和站内页面。站内的必须走 router-link，
                否则拿不到 /en 前缀（英文页会跳回中文页），也会整页刷新。
              -->
              <li v-for="item in $t('footer.links')">
                <router-link v-if="item.link.charAt(0) === '/'" :to="item.link" class="text-foot">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{item.text}}
                </router-link>
                <a v-else :href="item.link" class="text-foot" target="_blank" rel="noopener">
                  <i class="mdi mdi-chevron-right mr-1"></i> {{item.text}}
                </a>
              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-8">
            <div class="text-sm-left">
              <p class="mb-0">© 2016 - {{ new Date().getFullYear() }} 版权所有 @北京灵动无线网络科技有限公司 <a class="ml-2" href="https://beian.miit.gov.cn/" target="_blank">京ICP备2021009837号-2</a></p>
              <p class="mb-0">北京市海淀区永澄北路2号院1号楼B座5层5006-43号</p>
              <p class="mb-0">电话： 18500197901</p>
            </div>
          </div>
          <!--end col-->

          <div class="col-sm-4 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <ul class="list-unstyled text-sm-right mb-0">
              <li class="list-inline-item">

              </li>
            </ul>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </footer>
    <!--end footer-->

    <b-modal id="follow-modal1" size="sm" ref="login-modal" hide-footer
             :title="$t('index.contact.follow_title')"
             header-close-variant="white"
             no-close-on-backdrop
             header-class="border-0"
             content-class="border-0" centered >
      <div v-if="follow==='wechat'"><img width="310" height="400" loading="lazy" src="/images/index/wechat-qrcode.png" class="img-fluid" :alt="$t('alt.wechat_qr')"></div>
      <div v-if="follow==='qq'"><img width="980" height="1368" loading="lazy" src="/images/index/qq-group-qrcode.png" class="img-fluid" :alt="$t('alt.qq_qr')"></div>
    </b-modal>

  </div>
</template>
